// DATALIST 
export const FONDO_DATALIST_NAME: string = 'fund';
export const GRUPO_CLASIFICACION_DATALIST_NAME: string = 'classificationGroup';
export const CLASIFICACION_DATALIST_NAME: string = 'classification';
export const DIVISION_DATALIST_NAME: string = 'division';
export const SUBDIVISION_DATALIST_NAME: string = 'subdivision';
export const SUBDIVISION_ESP_DATALIST_NAME: string = 'specificSubdivision';
export const CATEGORIA_DATALIST_NAME: string = 'category';
export const TIPOLOGIA_DATALIST_NAME: string = 'typology';
export const TITULO_DATALIST_NAME: string = 'title';
export const NIVEL_DESC_DATALIST_NAME: string = 'descriptionLevel';
export const DEPOSITO_DATALIST_NAME: string = 'deposit';
export const DESCRIPTOR_DATALIST_NAME: string = 'descriptor';
export const CONSERVACION_DATALIST_NAME: string = 'conservation';
export const VALORACION_DATALIST_NAME: string = 'valuation';
export const ACCESO_DATALIST_NAME: string = 'access';
export const MESES_DATALIST_NAME: string = 'months';
export const QUINCENA_DATALIST_NAME: string = 'fortnight';
export const SUPPORT_DATALIST_NAME: string = 'support';
export const TRANSFER_ORDER_DATALIST_NAME: string = 'transfer-order';
export const METHOD_DATALIST_NAME: string = "loanMethods";

// BOUD DATALIST
export const BOUD_TYPES_DATALIST_NAME: string = 'types';
export const BOUD_SUBTYPES_DATALIST_NAME: string = 'subtypes';
export const BOUD_PRIMARY_APPROVING_BODY_DATALIST_NAME: string = 'primaryApprovingBody';
export const BOUD_SECONDARY_APPROVING_BODY_DATALIST_NAME: string = 'secondaryApprovingBody';
export const BOUD_SECONDARY_APPROVING_BODY_SUB_DATALIST_NAME: string = 'secondaryApprovingBodySub';
export const BOUD_ACTIONS_DATALIST_NAME: string = 'boudActions';

// GAUDE DATALIST 
export const SUBDIVISION_NOMINAL_GAUDE_DATALIST_NAME: string = 'GetSubdivisionNominal';
export const SUBDIVISION_NOMINAL_FACULTADES_GAUDE_DATALIST_NAME: string = 'GetFacultades';
export const SUBDIVISION_NOMINAL_ID_GAUDE_DATALIST_NAME: string = 'GetSubdivisionNominalID';
export const AUTOR_GAUDE_DATALIST_NAME: string = 'GetAutor';
export const ALUMNO_GAUDE_DATALIST_NAME: string = 'GetGaude';
export const CURSO_ALUMNO_GAUDE_DATALIST_NAME: string = 'GetDatosSGA';
export const ALUMNO_FORMACION_DATALIST_NAME: string = 'GetFormacionContinua';
export const CURSO_ALUMNO_FORMACION_DATALIST_NAME: string = 'GetAlumnosCurso';
export const EMPLEADO_DATALIST_NAME: string = 'GetEmpleado';

// KEY_VALUE
export const SMTDL_OPTION_ITEM_NODE_TYPE = "smtdl:optionItem";
export const COURSE_KEY: string = 'TransferenciaCurso';
export const ACTIVO_KEY: string = 'TransferenciaActivo';
export const SUPPORT_KEY: string = 'TransferenciaSoporte';